/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_CaptionInputs */

const en_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Caption:`)
};

const fr_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière légende :`)
};

const de_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Bildunterschrift:`)
};

const it_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima didascalia:`)
};

const ru_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последняя подпись:`)
};

const es_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último subtítulo:`)
};

const zh_cn2_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后一条说明文字：`)
};

const ja_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のキャプション:`)
};

const hi_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम कैप्शन:`)
};

const pt_pt2_last_caption = /** @type {(inputs: Last_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última legenda:`)
};

/**
* | output |
* | --- |
* | "Last Caption:" |
*
* @param {Last_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const last_caption = /** @type {((inputs?: Last_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_last_caption(inputs)
	if (locale === "de") return de_last_caption(inputs)
	if (locale === "it") return it_last_caption(inputs)
	if (locale === "ru") return ru_last_caption(inputs)
	if (locale === "es") return es_last_caption(inputs)
	if (locale === "zh-CN") return zh_cn2_last_caption(inputs)
	if (locale === "ja") return ja_last_caption(inputs)
	if (locale === "hi") return hi_last_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_last_caption(inputs)
	return en_last_caption(inputs)
});